export const pl = {
  nav: {
    home: "Strona Główna",
    about: "O nas",
    services: "Usługi",
    contact: "Kontakt",
    toggle: "Zmień język",
  },
  hero: {
    tag: "Autoryzowani Partnerzy",
    title: "Automatyka CNC",
    subtitle: "Profesjonalny serwis maszyn CNC",
    desc: "Serwis obrabiarek CNC wiodących światowych producentów.",
    btnServices: "Nasze Usługi",
    btnContact: "Skontaktuj się",
  },

  /* --- HOME --- */
  home: {
    offerTag: "Nasza Oferta",
    offerTitle: "Kompleksowe Usługi Serwisowe",
    offerDesc:
      "Wykonujemy specjalistyczne usługi serwisowe, modernizacyjne i przeglądowe obrabiarek i centrum obróbkowych CNC najwyższych klas.",
    services: [
      {
        name: "Instalacja po Relokacji",
        desc: "Osadzenie, kotwienie, poziomowanie precyzyjne i ustawianie geometrii statycznej dla maszyn po relokacji. Pomiar bicia wrzeciona.",
      },
      {
        name: "Diagnostyka Elektryczna",
        desc: "Usuwanie usterek, wymiana enkoderów i falowników. Tworzymy i instalujemy interface'y, a także kalibrujemy sondy narzędziowe.",
      },
      {
        name: "Diagnostyka Mechaniczna",
        desc: "Korekta geometrii, kompensacja luzów nawrotnych osi. Wymieniamy prowadnice, śruby kulowe oraz elementy instalacji pneumatycznej.",
      },
      {
        name: "Przeglądy Maszyn (PPM)",
        desc: "Kompleksowa inspekcja mechanizmów i systemów, wymiany filtrów/olejów wg producenta oraz tworzenie kopii zapasowych parametrów.",
      },
    ],
    learnMore: "Dowiedz się więcej",
    aboutTitle: "O nas i naszym doświadczeniu",
    aboutDesc:
      "Pracujemy w branży od 2007 roku, rozwijając kompetencje w diagnostyce i naprawie obrabiarek CNC. Jesteśmy oficjalnym partnerem serwisowym m.in. MAZAK i BLUM-Novotest.",
    aboutList: [
      "Doświadczenie w fabrykach MAZAK od 2007 r.",
      "Dawny autoryzowany serwis MAKINO Central Europe",
      "Oficjalne partnerstwo z MAZAK i BLUM-Novotest",
      "Specjalizacja: FANUC, MITSUBISHI, HEIDENHAIN",
    ],
    contactTitle: "Automatyka CNC - Dariusz Król",
    contactDesc:
      "Zadzwoń do nas lub wyślij wiadomość e-mail by dowiedzieć się więcej o naszych usługach.",
    contactBtnMail: "kontakt@automatyka-cnc.pl",
    contactBtnPhone: "Zadzwoń: +48 500 076 868",
  },

  /* --- SERVICES --- */
  uslugi: {
    tag: "Zakres naszej działalności",
    title: "Serwis od Podstaw",
    desc: "Realizujemy specjalistyczne, wszechstronne usługi serwisowe maszyn skrawających najpopularniejszych marek bazując na wieloletniej pracy w zespołach MAZAK i MAKINO.",
    contactBtn: "Zapytaj o wycenę usługi",
    list: [
      {
        tag: "Wsparcie w relokacji",
        name: "Instalacja Maszyn po Relokacji",
        desc: "Przeprowadzka elementów zakładu produkcyjnego to krytyczny i skomplikowany proces. Dbamy o to, by czas przestoju ograniczyć do niezbędnego minimum , a uruchomienie przeniesionej obrabiarki odbyło się sprawnie i szybko, zachowując gotowość do natychmiastowego rozpoczęcia precyzyjnej i stabilnej obróbki. Udzielamy wsparcia przy przeprowadzce sprzętu przez całą ścieżkę od przygotowania i zabezpieczenia maszyny do relokacji po pierwszy wiór w nowej lokalizacji.",
        bullets: [
          "Osadzenie na fundamencie i przygotowanie kotwienia",
          "Podłączenie urządzeń peryferyjnych maszyny",
          "Poziomowanie precyzyjne",
          "Ustawienie geometrii maszyny po relokacji",
          "Dostawienie magazynu narzędzi, zmieniacza palet, magazynu palet",
        ],
      },
      {
        tag: "Nierozpoznane alarmy",
        name: "Diagnostyka Usterek Elektrycznych",
        desc: "Niezaplanowany przestój maszyny to zawsze czarny scenariusz, który uderza w najgorszym możliwym momencie, narażając firmę na straty finansowe i utratę zaufania kontrahentów. Działamy natychmiastowo - precyzyjnie diagnozujemy przyczyny występowania alarmu oraz usterki sprzętowe i eliminujemy je, by bezzwłocznie przywrócić pełną ciągłość technologiczną Twojego procesu.",
        bullets: [
          "Diagnostyka i eliminowanie elektrycznych usterek wywołującyh alarm",
          "Wymiana napędów, falowników i enkoderów",
          "Korekta pozycji referencyjnych osi oraz pozycji wymiany narzędzi ATC",
          "Kalibracja systemów pomiaru narzędzi, a także sond materiałowych",
          "Integracja dodatkowych opcjonalnych systemów zewnętrznych",
        ],
      },
      {
        tag: "Wrzeciona i Geometria",
        name: "Diagnoza Usterek Mechanicznych",
        desc: "Zużycie wrzeciona czy części konstrukcyjnych maszyny postępuje z czasem, niezależnie od nas. Dodatkowo, kolizje przyspieszają proces zużycia i prawie zawsze zmieniają geometrię maszyny. Dokonujemy pomiarów oraz napraw mechanicznych najważniejszych podzespołów, w tym układów kinematycznych oraz hydraulicznych, a także przeprowadzamy ustawienie geometrii.",
        bullets: [
          "Pomiar i ustawienie geometrii statycznej maszyny",
          "Pomiar siły zacisku i bicia wrzeciona frezarskiego",
          "Sprawdzenie i kompensacja luzów nawrotnych osi",
          "Wymiana prowadnic i śrub kulowych osi",
          "Diagnoza i wymiana elementów układów hydraulicznych i pneumatycznych",
        ],
      },
      {
        tag: "Prewencyjne Utrzymanie",
        name: "Przeglądy Okresowe Maszyn (PPM)",
        desc: "Regularne przeglądy prewencyjne to mniejsze ryzyko poważnych usterek sprzętu. Wdrażamy i cyklicznie kontrolujemy stan maszyny, wrzeciono, geometrię, luzy oraz wymieniamy filtry, oleje, baterie i inne elementy eksploatacyjne, aby utrzymywać maszynę w optymalnej kondycji przez lata.",
        bullets: [
          "Inspekcja systemów, przewodów oraz mechanizmów maszyny",
          "Pomiar geometrii i luzów nawrotnych śrub kulowych",
          "Kontrola stanu wrzeciona frezarskiego",
          "Wymiana elementów eksploatacyjnych zgodnie z zaleceniami producenta",
          " Wykonanie kopii zapasowej parametrów",
        ],
      },
    ],
  },

  /* --- ABOUT --- */
  onas: {
    headerTag: "Nasza Historia",
    title: "Historia Naszego Doświadczenia",
    desc: "Od 2007 roku nieustannie budujemy nasze kompetencje w największych fabrykach i liniach produkcyjnych, kierując się japońską ideą.",
    paragraph1:
      "Nasze doświadczenie sięga roku 2007 - praca przy budowie obrabiarek Mazak na lini produkcyjnej w WORCESTER (UK). Od 2011 roku praca w serwisie MAZAK PL, a następnie od 2017 roku w serwisie MAKINO Central Europe. Od połowy 2023 roku prowadzimy działalność serwisową obrabiarek CNC głównie japońskich producentów, ale nie tylko. Aktualnie, jesteśmy partnerem serwisowym ",
    paragraph2: " oraz partnerem handlowo-serwisowym firm ",
    paragraph3: ".",
    pillarsTitle: "Fundamenty współpracy:",
    pillars: [
      "Autoryzowany partner serwisowy MAZAK",
      "Certyfikowane wsparcie i sprzedaż BLUM-Novotest",
      "Eksperci od układów FANUC i MITSUBISHI",
      "Wieloletnie zaplecze środowiska HEIDENHAIN",
    ],
    timeline: [
      {
        year: "2007",
        title: "Worcester, UK",
        description: "Praca w fabryce obrabiarek MAZAK na linii produkcyjnej. Fundament japońskiej precyzji.",
      },
      {
        year: "2011",
        title: "MAZAK Polska",
        description: "Dołączenie do zespołu serwisowego MAZAK PL. Intensywny rozwój kompetencji diagnostycznych.",
      },
      {
        year: "2017",
        title: "MAKINO Central Europe",
        description: "Praca w serwisie MAKINO. Specjalizacja w zaawansowanych systemach obróbczych bazujących na stystemach FANUC.",
      },
      {
        year: "2023",
        title: "Automatyka CNC",
        description: "Rozpoczęcie własnej działalności pod marką Automatyka CNC. Status oficjalnego partnera MAZAK i BLUM.",
      },
      {
        year: "2024",
        title: "Współpraca z Mechatronika CNC",
        description: "Nawiązanie współpracy z firmą Mechatronika CNC w zakresie serwisu oraz wzajemnego wsparcia technicznego.",
      },
    ],
    partnershipsTitle: "Autoryzowane Partnerstwa",
    partnershipsDesc: "Nasze kompetencje są potwierdzone bezpośrednią współpracą z liderami branży CNC. Gwarantujemy najwyższą jakość usług zgodną ze standardami producentów.",
    partners: [
      {
        name: "MAZAK",
        role: "Oficjalny Partner Serwisowy",
        desc: "Wieloletnie doświadczenie w fabrykach i serwisie MAZAK od 2007 roku.",
      },
      {
        name: "BLUM-Novotest",
        role: "Certyfikowany Partner Handlowo-Serwisowy",
        desc: "Autoryzowane wsparcie techniczne i sprzedaż systemów pomiarowych BLUM.",
      },
    ],
    galleryTitle: "Galeria Realizacji",
    galleryDesc: "Zobacz naszą codzienną pracę przy najbardziej wymagających systemach CNC. Precyzja i profesjonalizm w każdym szczególe.",
  },

  /* --- CONTACT --- */
  kontakt: {
    title: "Skontaktuj się z nami",
    subtitle: "Masz pytania dotyczące serwisu CNC, modernizacji lub relokacji maszyn? Napisz do nas.",
    dataTitle: "Nasze Dane",
    locationTitle: "Lokalizacja",
    locationValue: "Łukowica, Polska",
    phoneTitle: "Telefon Kontaktowy",
    emailTitle: "Adres E-mail",
    socialTitle: "Znajdź nas w sieci:",
  },
  footer: {
    allRightsReserved: "Wszelkie prawa zastrzeżone.",
  },
} as const;
